import { Tab, Tabs, Typography } from '@mui/material';
import Box from '@mui/material/Box/Box';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { TranslateText } from '../../../../application/language/TranslateText';
import { IProjectLearningReportArg } from '../../../../service/report/interface/IProjectLearningReportArg';
import { ProjectRatingsContent } from './ProjectRatingsContent';
import { UserRatingsContent } from './UserRatingsContent';
import { RatingsSectionDomain } from './store/RatingsSectionDomain';

type IRatingsSectionProperties = {
  reportArg?: IProjectLearningReportArg;
};

export const RatingsSection = observer(({ reportArg = {} }: IRatingsSectionProperties) => {
  const [{ tab, setTab }] = useState(() => new RatingsSectionDomain());

  const changeTab = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ mt: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <Typography variant="h6">
          <TranslateText i18nKey="analytics.ratingTitle" />
        </Typography>
        <Tabs value={tab.value} onChange={changeTab}>
          <Tab label={<TranslateText i18nKey="analytics.projects" />} sx={{ textTransform: 'none' }} />
          <Tab label={<TranslateText i18nKey="analytics.users" />} sx={{ textTransform: 'none' }} />
        </Tabs>
      </Box>
      {tab.value === 0 ? <ProjectRatingsContent reportArg={reportArg} /> : null}
      {tab.value === 1 ? <UserRatingsContent reportArg={reportArg} /> : null}
    </Box>
  );
});
